import _pick from 'lodash/pick';
import _get from 'lodash/get';
export const getValueFromEnv = keys => {
  const envVariable = process.env;
  if (Array.isArray(keys) && keys.length > 0) {
    return _pick(envVariable, keys);
  } else {
    return _get(envVariable, keys);
  }
};
export const getLoginPageUrl = () => {
  const {
    LOGIN_PAGE_URL
  } = process.env;
  return LOGIN_PAGE_URL || '/login';
};

/**
 * @description Function to sanitize url
 * @param {String} url url that needs to be sanitized
 * @returns false/url
 */
export const sanitizeUrl = url => {
  const invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
  const ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
  const urlSchemeRegex = /^([^:]+):/gm;
  const relativeFirstCharacters = ['.', '/'];
  const isRelativeUrlWithoutProtocol = URL => relativeFirstCharacters.indexOf(URL[0]) > -1;
  if (!url) {
    return false;
  }
  const sanitizedUrl = url.replace(ctrlCharactersRegex, '').trim();
  if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
    return sanitizedUrl;
  }
  const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
  if (!urlSchemeParseResults) {
    return sanitizedUrl;
  }
  const urlScheme = urlSchemeParseResults[0];
  if (invalidProtocolRegex.test(urlScheme)) {
    return false;
  }
  return validateUrl(sanitizedUrl);
};

/**
 * @description Function to validate url
 * @param {string} url - url which needs to be validated
 * @returns {boolean} - false / url
 */
export const validateUrl = url => {
  let validUrl;
  try {
    validUrl = new URL(url);
  } catch {
    return false;
  }
  if (validUrl.host === window.location.host) {
    return url;
  }
  return false;
};

/*
* @description Function to check if given object/array/string/map value is empty or not.
* @param {Any} value - Input value to be checked if empty / not empty.
* @return {Boolean} - true/false
*/
export const isEmpty = value => {
  try {
    if (!value) {
      return true;
    }
    if (Array.isArray(value) && !value.length) {
      return true;
    }
    if (value.constructor.name === 'Map' && value.size === 0) {
      return true;
    }
    if (typeof value === 'object') {
      const keysArray = Object.keys(value);
      if (!keysArray.length) {
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
};